// Extracted function for the sake of easy testing
export function shouldRedirectToLogin({
	isReady,
	logged,
	guestEmail,
	isGuestAllowed,
}: {
	isReady: boolean
	logged: boolean
	guestEmail: string | null
	isGuestAllowed: boolean
}) {
	const isGuestLoggedWithOrder = !logged && !!guestEmail && isGuestAllowed

	return isReady && !(logged || isGuestLoggedWithOrder)
}
